/* eslint-disable */
import { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import {
    Container, Stack, TextField, Box, Typography, Grid
} from '@material-ui/core';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import services from '../Service';
import Button from '@material-ui/core/Button';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import SearchNotFound from '../../../SearchNotFound';
import { Autocomplete } from '@mui/material';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import { LoadingComponent } from 'src/pages/pageLoader';
import { GoodsInvoiceTable } from './InvoiceTable';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

var screenCode = 'GOODSRECEIVEDNOTE';

export default function GoodsReceivedNote(props) {
    const componentRef = useRef([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [groupList, setGroupList] = useState([]);
    const [groupListTwo, setGroupListTwo] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [operationEntityListTwo, setOperationEntityListTwo] = useState([]);
    const [farmer, setFarmer] = useState([]);
    const [directSupllierDetails, setDirectSupllierDetails] = useState([]);
    const [goodHeaderDetails, setGoodHeaderDetails] = useState([]);
    const [notCompleteGoodHeaderDetails, setNotCompleteGoodHeaderDetails] = useState([]);
    const [goodDetails, setGoodDetails] = useState([]);
    const [notCompleteGoodDetails, setNotCompleteGoodDetails] = useState([]);
    const [notCompletePriceNegotiation, setNotCompletePriceNegotiation] = useState([]);
    const [IsFarmerClear, setIsFarmerClear] = useState(false);
    const [selectedFarmer, setSelectedFarmer] = useState([]);
    const [selectedDirectSupplier, setSelectedDirectSupplier] = useState([]);

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        submitButtonName: 'Generate',
        pageheadername: 'Goods Received Note'
    });
    const [date, setDate] = useState(new Date());

    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: 0,
        supplierTypeID: 1,
        farmerID: 0,
        directSupplierID: 0,
        dataID: '0',
        rejectReason: ''
    });

    const [message, setMessage] = useState("Reject Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [selectedData, setSelectedData] = useState([]);

    const [farmerDa, setFarmerata] = useState({
        supplierTypeID: 1
    });

    const goodsReceivedNoteSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.number().min(1, 'Please Select Fresh Collection Center').required('Fresh Collection Center is required'),
        supplierTypeID: Yup.number().min(1, 'Please Select Supplier Type').required('Supplier Type required'),
        farmerID: farmerDa.supplierTypeID == 1 ? Yup.number().min(1, 'Please Select Farmer').required('Farmer required') : Yup.number().notRequired(),
        directSupplierID: farmerDa.supplierTypeID == 2 ? Yup.number().min(1, 'Please Select Direct Supplier').required('Direct Supplier required') : Yup.number().notRequired(),
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            supplierTypeID: formData.supplierTypeID,
            farmerID: formData.farmerID,
            directSupplierID: formData.directSupplierID,
        },

        validationSchema: goodsReceivedNoteSchema,
        onSubmit: (values) => {
            trackPromise(SearchData());
        }
    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        trackPromise(GetFarmerDetailsByFactoryIDRouteID(), GetDirectSupplierDetails());
        setGoodDetails([])
        setNotCompleteGoodDetails([])
        setIsFarmerClear(!IsFarmerClear)
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setGoodDetails([])
        setNotCompleteGoodDetails([])
    }, [date]);

    useEffect(() => {
        setGoodDetails([])
        setNotCompleteGoodDetails([])
    }, [formik.values.farmerID]);

    useEffect(() => {
        setGoodDetails([])
        setNotCompleteGoodDetails([])
    }, [formik.values.directSupplierID]);

    useEffect(() => {
        setGoodDetails([])
        setNotCompleteGoodDetails([])
        setIsFarmerClear(!IsFarmerClear)
    }, [farmerDa.supplierTypeID]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find((p) => p.permissionCode == 'VIEWGOODSRECEIVEDNOTE');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        });
        trackPromise(GetAllGroups());
    }

    async function GetAllGroups() {
        var groupArray = [];
        var res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
            for (let item of Object.entries(res)) {
                groupArray[item[1]["groupID"]] = item[1]["groupName"]
            }
            setGroupListTwo(groupArray)
        }
    }

    async function GetOperationEntityByGroupID() {
        var factoryArray = [];
        var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
            for (let item of Object.entries(res)) {
                if (item[1]["factoryType"] === 2) {
                    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
                }
            }
            setOperationEntityListTwo(factoryArray)
        }
    }

    async function GetFarmerDetailsByFactoryIDRouteID() {
        var res = await services.GetFarmerDetailsByFactoryIDRouteID(formik.values.operationEntityID)

        if (res != null) {
            setFarmer(res);
        }
    }

    async function GetDirectSupplierDetails() {
        var res = await services.GetDirectSupplierDetails(formik.values.operationEntityID);
        if (res != null) {
            let newRes = res.filter(x => x.isActive == 1)
            setDirectSupllierDetails(newRes);
        }
    }

    async function SearchData() {
        setGoodHeaderDetails([]);
        setNotCompleteGoodHeaderDetails([]);
        setNotCompleteGoodDetails([]);
        setGoodDetails([]);

        let model = {
            operationEntityID: formik.values.operationEntityID,
            supplierTypeID: parseInt(farmerDa.supplierTypeID),
            farmerID: farmerDa.supplierTypeID == 1 ? parseInt(formik.values.farmerID) : parseInt(formik.values.directSupplierID),
            date: new Date(date).toISOString()
        };
        const Result = await services.GetGoodsReceivedNoteDetails(model);
        if (Result.length != 0) {
            const completeResult = Result.filter(x => x.isComplete == true)
            const notCompleteResult = Result.filter(x => x.isComplete == false)
            const found = notCompleteResult.filter(x => x.realizedPrice == 0)
            setNotCompletePriceNegotiation(found)
            let header = [];
            completeResult.forEach(x => {
                const sum = x.goodDetails.reduce((accumulator, object) => {
                    return accumulator + object.totalAmount;
                }, 0);
                var currentdate = new Date();
                var datetime = currentdate.getDate() + "/"
                    + (currentdate.getMonth() + 1) + "/"
                    + currentdate.getFullYear() + " "
                    + currentdate.getHours() + ":"
                    + currentdate.getMinutes() + ":"
                    + currentdate.getSeconds();
                header.push({
                    fullName: x.goodDetails[0].farmerCode + ' - ' + x.goodDetails[0].givenName,
                    total: sum,
                    orderDate: new Date(date).toISOString(),
                    currentDate: datetime,
                    groupName: groupListTwo[formik.values.groupID],
                    factoryName: operationEntityListTwo[formik.values.operationEntityID],
                    invoiceNo: x.invoiceNumber,
                    orderNo: x.goodDetails[0].performOrderCode,
                    invoiceType: x.goodDetails[0].farmerStatus
                });
            })
            let headerOne = [];
            notCompleteResult.forEach(x => {
                const sum = x.goodDetails.reduce((accumulator, object) => {
                    return accumulator + object.totalAmount;
                }, 0);
                var currentdate = new Date();
                var datetime = currentdate.getDate() + "/"
                    + (currentdate.getMonth() + 1) + "/"
                    + currentdate.getFullYear() + " "
                    + currentdate.getHours() + ":"
                    + currentdate.getMinutes() + ":"
                    + currentdate.getSeconds();
                headerOne.push({
                    fullName: x.goodDetails[0].farmerCode + ' - ' + x.goodDetails[0].givenName,
                    total: sum,
                    orderDate: new Date(date).toISOString(),
                    currentDate: datetime,
                    groupName: groupListTwo[formik.values.groupID],
                    factoryName: operationEntityListTwo[formik.values.operationEntityID],
                    invoiceNo: x.invoiceNumber,
                    orderNo: x.goodDetails[0].performOrderCode,
                    invoiceType: null
                });
            })
            setGoodHeaderDetails(header);
            setNotCompleteGoodHeaderDetails(headerOne);
            setGoodDetails(completeResult);
            setNotCompleteGoodDetails(notCompleteResult);
        }
        else {
            setGoodDetails([])
            setNotCompleteGoodDetails([])
        }
    }

    function handleChangeType(e) {
        const target = e.target;
        const value = target.value

        setFarmerata({
            ...farmerDa,
            supplierTypeID: value
        });
    }

    async function clearAll() {
        setIsFarmerClear(!IsFarmerClear);
        setGoodDetails([])
        setNotCompleteGoodDetails([])
        setSelectedDirectSupplier([])
        setValues({
            ...values,
            farmerID: "0",
            operationEntityID: "0",
        });
        setDate(new Date());
    }

    async function grnComplete(data) {
        let newinitialData = _.cloneDeep(data);
        let newArray = [];
        newinitialData.forEach(x => {
            x.goodDetails.forEach(y => {
                newArray.push(y)
            })
        })
        newArray.forEach(x => {
            x.createdBy = parseInt(TokenDecoder.getUserIDFromToken())
        })
        var res = await services.GoodsReceivedNoteComplete(newArray)
        if (res.statusCode === "Success") {
            toast.success(res.message);
            trackPromise(SearchData());
        } else {
            toast.error(res.message);
        }
    }

    async function grnReject(data) {
        if (formData.rejectReason != "") {
            let newinitialData = _.cloneDeep(data);
            let newArray = [];
            newinitialData.forEach(x => {
                x.goodDetails.forEach(y => {
                    newArray.push(y)
                })
            })
            newArray.forEach(x => {
                x.createdBy = parseInt(TokenDecoder.getUserIDFromToken())
                x.rejectReason = formData.rejectReason
                x.grnDate = new Date(date).toISOString()
            })
            var res = await services.GoodsReceivedNoteReject(newArray)
            if (res.statusCode === "Success") {
                toast.success(res.message);
                trackPromise(SearchData());
                handleClose();
            } else {
                toast.error(res.message);
            }
        }
        else {
            toast.error("Reject Reason Required");
        }
    }

    async function handleAfterPrint(data) {
        let newinitialData = _.cloneDeep(data);
        let model = {
            invoiceNumber: newinitialData.invoiceNumber,
            modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
        };
        var res = await services.GoodsReceivedNoteDownloadCount(model)
    }

    const filterOptions = (options, { inputValue }) => {
        const trimmedInput = inputValue.trim().toLowerCase();
        const filteredOptions = options.filter(option =>
            (option.givenName && option.givenName.toLowerCase().includes(trimmedInput)) ||
            (option.nic && option.nic.toLowerCase().startsWith(trimmedInput)) ||
            (option.farmerCode && option.farmerCode.toLowerCase().startsWith(trimmedInput))
        ).filter(option => option.givenName !== null && option.nic !== null && option.farmerCode !== null);

        const exactMatchOptions = [];
        const nonExactMatchOptions = [];
        filteredOptions.forEach(option => {
            if (
                option.givenName.toLowerCase() === trimmedInput ||
                option.nic.toLowerCase() === trimmedInput ||
                option.farmerCode.toLowerCase() === trimmedInput
            ) {
                exactMatchOptions.push(option);
            } else {
                nonExactMatchOptions.push(option);
            }
        });
        return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
    };

    const filterOptionsOne = (options, { inputValue }) => {
        const trimmedInput = inputValue.trim().toLowerCase();

        const filteredOptions = options.filter(option =>
            (option.supplierName && option.supplierName.toLowerCase().includes(trimmedInput)) ||
            (option.nic && option.nic.toLowerCase().startsWith(trimmedInput))
        ).filter(option => option.supplierName !== null && option.nic !== null
        );

        const exactMatchOptions = [];
        const nonExactMatchOptions = [];
        filteredOptions.forEach(option => {
            if (
                option.supplierName.toLowerCase() === trimmedInput ||
                option.nic.toLowerCase() === trimmedInput
            ) {
                exactMatchOptions.push(option);
            } else {
                nonExactMatchOptions.push(option);
            }
        });
        return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
    };

    function handleSearchDropdownChangePrefferdName(data, e) {
        if (data === undefined || data === null) {
            setSelectedFarmer(data);
            setValues({
                ...values,
                farmerID: '0'
            });
            return;
        } else {
            setSelectedFarmer(data);
            var nameP = 'farmerID';
            var valueP = data.farmerID;
            setValues({
                ...values,
                farmerID: valueP
            });
        }
    }

    function handleSearchDropdownChangePrefferdNameOne(data, e) {
        if (data === undefined || data === null) {
            setSelectedDirectSupplier(data);
            setValues({
                ...values,
                directSupplierID: '0'
            });
            return;
        } else {
            setSelectedDirectSupplier(data);
            var nameP = 'directSupplierID';
            var valueP = data.directSupplierID;
            setValues({
                ...values,
                directSupplierID: valueP
            });
        }
    }

    async function handleConfirm(notCompleteGoodDetails) {
        setEnableConfirmMessage(true);
        setSelectedData(notCompleteGoodDetails);
    }

    function handleRejectReason(e) {
        const target = e.target;
        const value = target.value
        setFormData({
            ...formData,
            [e.target.name]: value
        });
    }

    function handleClose() {
        setEnableConfirmMessage(false);
        setFormData({
            ...formData,
            rejectReason: ""
        })
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Goods Received Note  |  FAPS">
                <Container>
                    <CommonPageHeader path="/dashboard" btname="Back" pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Fresh Collection Center *"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Fresh Collection Centers</MenuItem>
                                        {operationEntityList.map((option) => (
                                            option.factoryType == 2 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        id="outlined-basic"
                                        name='supplierTypeID'
                                        variant="outlined"
                                        label="Supplier Type *"
                                        value={farmerDa.supplierTypeID}
                                        onChange={(e) => { handleChangeType(e) }}
                                    >
                                        <MenuItem value={1}> Registered Suppliers</MenuItem>
                                        <MenuItem value={2}> Direct Supplier</MenuItem>
                                    </TextField>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    {farmerDa.supplierTypeID == 1 ?
                                        <Autocomplete
                                            fullWidth
                                            key={IsFarmerClear}
                                            clearOnEscape
                                            id="farmerID"
                                            options={farmer}
                                            filterOptions={filterOptions}
                                            getOptionLabel={(option) => `${option.givenName} - ${option.nic}`}
                                            onChange={(e, value) => handleSearchDropdownChangePrefferdName(value, e)}
                                            renderOption={(props, option) => (
                                                <li {...props}>
                                                    {`${option.givenName} - ${option.nic}`}
                                                </li>
                                            )}
                                            renderInput={(params) =>
                                                <TextField {...params}
                                                    variant="outlined"
                                                    name="farmerID"
                                                    label="Supplier Preferred Name / NIC *"
                                                    size="small"
                                                    fullWidth
                                                    helperText={touched.farmerID && errors.farmerID}
                                                    error={Boolean(touched.farmerID && errors.farmerID)}
                                                />
                                            }
                                        />
                                        :
                                        <Autocomplete
                                            fullWidth
                                            key={IsFarmerClear}
                                            clearOnEscape
                                            id="directSupplierID"
                                            options={directSupllierDetails}
                                            filterOptions={filterOptionsOne}
                                            getOptionLabel={(option) => `${option.supplierName} - ${option.nic}`}
                                            onChange={(e, value) => handleSearchDropdownChangePrefferdNameOne(value, e)}
                                            renderOption={(props, option) => (
                                                <li {...props}>
                                                    {`${option.supplierName} - ${option.nic}`}
                                                </li>
                                            )}
                                            renderInput={(params) =>
                                                <TextField {...params}
                                                    variant="outlined"
                                                    name="directSupplierID"
                                                    label="Direct Supllier Preferred Name / NIC *"
                                                    size="small"
                                                    fullWidth
                                                    helperText={touched.directSupplierID && errors.directSupplierID}
                                                    error={Boolean(touched.directSupplierID && errors.directSupplierID)}
                                                />
                                            }
                                        />}
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select Date"
                                            value={date}
                                            onChange={(newValue) => {
                                                setDate(newValue);
                                            }}

                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('date')}
                                                error={Boolean(touched.date && errors.date)}
                                                helperText={touched.date && errors.date}

                                                {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <Grid item md={4} xs={12}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button type="button" variant="outlined" color="error" onClick={() => clearAll()}>
                                                Clear
                                            </Button>
                                            <Button type="submit" color="secondary" variant="outlined" >
                                                Search
                                            </Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {notCompleteGoodDetails.length > 0 || goodDetails.length > 0 ?
                        <>
                            {notCompleteGoodDetails.length > 0 && notCompleteGoodHeaderDetails.length > 0 ?
                                <Stack direction={{ xs: 'column', sm: 'column' }} justifyContent="center">
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="center" >
                                        <Typography variant="h7" gutterBottom justifyContent="center">
                                            <b> Incomplete GRN List</b>
                                        </Typography>
                                    </Stack>
                                    {notCompletePriceNegotiation.length == 0 ?
                                        <>
                                            {notCompleteGoodDetails.map((res, index) => {
                                                const farmerData = notCompleteGoodHeaderDetails.find(x => x.invoiceNo == res.invoiceNumber)
                                                componentRef.current[index] = componentRef.current[index]
                                                return (
                                                    <>
                                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="center">
                                                            <GoodsInvoiceTable
                                                                farmerData={farmerData}
                                                                res={res}
                                                                key={index}
                                                            />
                                                        </Stack>
                                                        <Box display="flex" justifyContent="flex-end" p={2}>
                                                            <Button
                                                                color="secondary"
                                                                id="btnRecord"
                                                                type="button"
                                                                variant="contained"
                                                                onClick={() => handleConfirm(notCompleteGoodDetails)}
                                                                style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                                            >
                                                                Reject
                                                            </Button>
                                                            <Button
                                                                color="primary"
                                                                id="btnRecord"
                                                                type="button"
                                                                variant="contained"
                                                                onClick={() => trackPromise(grnComplete(notCompleteGoodDetails))}
                                                                style={{ marginRight: '1rem', backgroundColor: 'blue' }}
                                                            >
                                                                Complete
                                                            </Button>
                                                        </Box>
                                                    </>
                                                )
                                            })}
                                        </>
                                        :
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="center" >
                                            <Typography variant="h8" gutterBottom justifyContent="center">
                                                <b> Please Complete The Price Negotiation</b>
                                            </Typography>
                                        </Stack>}
                                </Stack> : null}
                            {goodDetails.length > 0 && goodHeaderDetails.length > 0 ?
                                <Stack direction={{ xs: 'column', sm: 'column' }} justifyContent="center">
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="center" >
                                        <Typography variant="h7" gutterBottom>
                                            <b> Completed GRN List</b>
                                        </Typography>
                                    </Stack>
                                    {goodDetails.map((res, index) => {
                                        const farmerData = goodHeaderDetails.find(x => x.invoiceNo == res.invoiceNumber)
                                        componentRef.current[index] = componentRef.current[index]
                                        return (
                                            <>
                                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="center">
                                                    <GoodsInvoiceTable
                                                        farmerData={farmerData}
                                                        res={res}
                                                        key={index}
                                                    />
                                                </Stack>
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <ReactToPrint
                                                        documentTitle={"Goods Receive Note"}
                                                        onAfterPrint={() => trackPromise(handleAfterPrint(res))}
                                                        trigger={() =>
                                                            <Button
                                                                color="primary"
                                                                id="btnRecord"
                                                                type="submit"
                                                                variant="contained"
                                                                style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                                            >
                                                                PDF
                                                            </Button>
                                                        }
                                                        content={() => componentRef.current[index]}
                                                    />
                                                    <div hidden={true}>
                                                        <CreatePDF
                                                            ref={(el) => (componentRef.current[index] = el)}
                                                            goodDetails={res.goodDetails}
                                                            farmerData={farmerData}
                                                        />
                                                    </div>
                                                </Box>
                                            </>
                                        )
                                    })}
                                </Stack> : null}
                        </>
                        : <SearchNotFound searchQuery="Goods Received Note" />}
                </Container>
            </Page>
            <div hidden={true}>
                <Dialog fullWidth={true} maxWidth='sm' onClose={handleClose} aria-labelledby="customized-dialog-title" open={EnableConfirmMessage}>
                    <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                        Reject Confirmation !
                    </DialogTitle>
                    <DialogContent dividers>
                        <Grid item md={12} xs={12}>
                            <TextField
                                fullWidth
                                id="outlined-multiline-static"
                                label="Reject Reason *"
                                name='rejectReason'
                                value={formData.rejectReason}
                                onChange={(e) => { handleRejectReason(e) }}
                                multiline
                                rows={4}
                                variant="outlined"
                            />
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={() => trackPromise(grnReject(selectedData))} variant="contained" color="error">
                            Reject
                        </Button>
                        <Button autoFocus onClick={handleClose} variant="outlined" color="secondary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    );
}

